<template>
  <general-item format="popup">
    <span slot="title">{{ $t('edit.sidebar.in_a_popup') }}</span>
    <span slot="description">{{ $t('edit.sidebar.one_box_apper_in_the_middle') }}</span>
  </general-item>
</template>

<script>
import GeneralItem from './GeneralItem';

export default {
  components: {
    GeneralItem,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Popup.vue?7a9b669c
 **/